module.exports = __webpack_public_path__ + "img/sneezing_face.89927507.gif";